import type {FinancialAid, JWTInstructor, JWTUser} from "@/components/Providers/JWTProvider.tsx";

export const getRegistrationFinancialAid = (
    user: JWTUser | JWTInstructor | null | undefined,
): FinancialAid => {
    if (!(user && "financialAid" in user)) {
        return "none";
    }

    return user.financialAidRegistration ?? user.financialAid ?? "none";
};
